import { makeStyles, fade } from '@material-ui/core/styles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    borderBottom: `1px dashed ${theme.palette.action.disabled}`,
    padding: '10px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -theme.spacing(1),
  },
  containerTemplate: {
    backgroundColor: fade(colors.danger, 0.25),
  },
  templateTextContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: 12,

    '& b': {
      fontSize: 16,
      marginBottom: theme.spacing(0.5),
    },
  },
  select: {
    borderRadius: 4,
    marginLeft: theme.spacing(1),
    '& .MuiFilledInput-input': {
      padding: '5px 12px 6px',
      paddingRight: 32,
    },
  },
}));

export default useStyles;
